import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Icon, Select, Tabs, Title} from '../components';
import SweetAlert from "react-bootstrap-sweetalert";
import { useGetDataVendorUsersQuery } from '../../api/dataVendorUserApiSlice';
import { useCreateDataVendorAwsCredMutation } from '../../api/dataVendorAwsCredsApiSlice';

const PhoneFeedback = ({phoneNumber}) => {
  const { t } = useTranslation();
  const isValid = !!phoneNumber
  const message = isValid ? t('users.phoneNumber') + ' : ' + phoneNumber : t('users.missingPhone')

  return (
    <Alert variant={isValid ? "light" : "danger"}>
      {message}
    </Alert>
  )
}

export const SendCredsModal = ({show, setShow}) => {
  const handleClose = () => setShow(false);
  const { t } = useTranslation();
  const { dataVendorKey } = useParams();
  const [selectedUser, setSelectedUser] = useState()
  const [valid, setValid] = useState(false)
  const {data: users = [], isSuccess} = useGetDataVendorUsersQuery(dataVendorKey)
  const [ sendCreds ] = useCreateDataVendorAwsCredMutation()
  const [showResetAwsAlert, setShowResetAwsAlert] = useState(false)
  const handleResetCredsClick = () => {
    sendCreds([dataVendorKey, selectedUser.id]).unwrap()
      .then(()=>{
        setShowResetAwsAlert(false)
        setShow(false)
      })
      .catch(error => {})
  }
  const isMissingPhone = () => {
    return ! selectedUser?.phoneNumber
  }
  useEffect(() => {
    setValid(!isMissingPhone() && !!selectedUser?.id)
  }, [selectedUser])

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("dataVendors.send_aws")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form.Group controlId="UserId">
          <Form.Label>{t('dataVendor.users')}</Form.Label>
          <Select isClearable={false} placeholder={t("dataVendor.users")} value={selectedUser} onChange={(e)=>{setSelectedUser(e)}}>
            {
              users.map((u, i)=>{
                return (
                  <Option key={i} value={u}>{u.firstName} {u.lastName} ({u.email})</Option>
                )
              })
            }
          </Select>
          {selectedUser && <PhoneFeedback phoneNumber={selectedUser?.phoneNumber}/>}
        </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("cancel")}
          </Button>
          <Button variant="primary" disabled={!valid} key="send_aws" onClick={()=>{setShowResetAwsAlert(true)}}>
            <Icon icon='aws' text={t("dataVendors.send_aws")} />
          </Button>
        </Modal.Footer>
      </Modal>
      {showResetAwsAlert && <SweetAlert warning
                                        showCancel
                                        title={t("confirm?")}
                                        confirmBtnText={t("dataVendors.send_aws")}
                                        confirmBtnBsStyle="danger"
                                        cancelBtnText={t("cancel")}
                                        cancelBtnBsStyle="light"
                                        onConfirm={handleResetCredsClick}
                                        onCancel={()=>{setShowResetAwsAlert(false)}}>
          <p>{selectedUser.email}</p>
      </SweetAlert>}
    </>
   );
}